<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix m-b-10">
      <div class="pull-left">
        <h3 class="m-v-5">成果详情</h3>
      </div>
    </div>
    <template v-if="!is_admin">
      <div class="check-title" @click="show = !show" :class="[{'c-p':achievement.checker}]">
        <div :class="['text-'+status_map[achievement.status].color]">
          {{status_map[achievement.status].name}}
        </div>
        <icon v-if="achievement.checker" class="collapse-chevron"
              :name="show?'chevron-down': 'chevron-right'"></icon>
      </div>
      <el-form v-if="achievement.checker&&show" class="check-detail" label-width="6em" label-position="left">
        <el-form-item label="审核人">{{achievement.checker}}</el-form-item>
        <el-form-item label="审核时间">{{achievement.check_time}}</el-form-item>
        <el-form-item label="留言">{{achievement.reason}}</el-form-item>
      </el-form>
    </template>
    <div class="block">
      <el-form :label-width="label_width+'em'" label-position="left">
        <el-form-item label="类型">{{type.name}}</el-form-item>
        <el-row :gutter="20">
          <div v-for="(item, index) in type.form" :key="index">
            <el-col v-if="item.type === 'file'">
              <el-form-item :label="item.name">
                <div class="preview-file">
                  <div class="preview-file-item" :key="index"
                       v-for="(file, index) in achievement[item.prop]">
                    <div class="preview-container">
                      <img v-img-pop="getImage(achievement[item.prop])"
                           v-if="$isImage(file.url)" :src="file.url">
                      <icon v-else :name="file.url | fileicon"></icon>
                    </div>
                    <a :href="file.url" download target="_blank" class="link-success">{{file.name}}</a>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col v-else-if="item.type === 'select' && item.multiple" :span="24">
              <el-form-item :label="item.name">
                {{achievement[item.prop].join('、')}}
              </el-form-item>
            </el-col>
            <el-col v-else :span="12">
              <el-form-item :label="item.name">
                {{ achievement[item.prop] }}
              </el-form-item>
            </el-col>
          </div>
        </el-row>
        <el-form-item v-if="is_check" label="留言">
          <el-input type="textarea" :autosize="{min: 3}" v-model="reason"></el-input>
          <div class="text-danger">* 不通过必填</div>
        </el-form-item>
        <div class="text-center m-v-10">
          <template v-if="!is_admin&&can_modify">
            <router-link :to="$location.achievement_edit()"
                         class="el-button el-button--success el-button--cons">
              编辑，重新提交
            </router-link>
            <el-button type="danger" size="cons" @click="deleteAchievement()" :loading="submit_loading>0">
              删除
            </el-button>
          </template>
          <template v-if="is_check">
            <el-button type="success" size="cons" @click="check(true)" :loading="submit_loading>0">通过
            </el-button>
            <el-button type="danger" size="cons" @click="check(false)" :loading="submit_loading>0">不通过
            </el-button>
          </template>
          <el-button type="default" size="cons" @click="$router.back()">返回</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import maxBy from 'lodash/maxBy'
import keyBy from 'lodash/keyBy'
import * as Achievement from 'api/achievement'

export default {
  data () {
    return {
      ready: false,
      list: [],
      type: null,
      achievement: null,
      submit_loading: 0,
      visible: false,
      show: false,
      reason: '',
      can_modify: false,
    }
  },
  computed: {
    is_check () {
      return this.$route.name === this.$location.admin_achievement_check().name
    },
    is_admin () {
      return this.$route.name === this.$location.admin_achievement_check().name ||
        this.$route.name === this.$location.admin_achievement_view().name
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [types, achievement, status] = await Promise.all([
          Achievement.types(),
          Achievement.get({uid: this.$query.achievement_uid}),
          Achievement.status(),
        ])
        let type = keyBy(types, 'id')[achievement.type]
        let status_map = keyBy(status, 'id')
        this.label_width = maxBy(type.form, item => item.name.length).name.length + 2
        this.type = type
        this.achievement = achievement
        this.can_modify = Achievement.can_modify(this.achievement)
        this.status = status
        this.status_map = status_map
        this.show = Achievement.is_no_pass(achievement)
        this.ready = true
      })
    },
    async deleteAchievement () {
      if (!await this.$dangerConfirm('您确定要删除该成果吗？')) return
      this.$guard(this, 'submit_loading')(async () => {
        await Achievement.remove({data: [{uid: this.achievement.uid}]})
        this.$message.success('提交成功')
        this.$router.back()
      })
    },
    check (check) {
      if (!check && !this.reason.trim()) {
        this.$message('不通过必须填写留言')
        return
      }
      this.$guard(this, 'submit_loading')(async () => {
        let data = [{uid: this.achievement.uid, check: check, reason: this.reason}]
        await Achievement.check({data})
        this.$router.back()
      })
    },
    getImage (files) {
      return files.filter(file => this.$isImage(file.url)).map(file => ({src: file.url, name: file.name}))
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors.scss";

.el-form-item {
  margin-bottom: 10px;
}

.check-title, .check-detail {
  padding: 10px 20px;
  background-color: #eee;
}

.check-title {
  user-select: none;
  font-size: 1.2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .collapse-chevron {
    border-color: transparent;
    color: black;
    padding: 0;
    transition: color 0.3s ease;
    font-size: 1em;
  }
  .collapse-chevron:focus, .collapse-chevron:hover {
    color: transparentize(black, 0.4);
  }
}

.check-detail {
  padding-top: 0;
}

.block {
  padding: 20px;
  background-color: $color-block-background;
}

</style>



// WEBPACK FOOTER //
// src/components/achievement/AchievementView.vue